module.exports = __webpack_public_path__ + "img/home-img-2.9e866a40.png";